export const TRIGGER_VISIBILITY_EVENTS = {
    TRIGGER_VISIBILITY_CHANGED: 'triggerVisibilityChanged',
} as const;


export const TRIGGER_HIDE_REASONS = {
    EXTERNAL_CHECKOUT: 'externalCheckout',
    CHATBOT: 'chatbot',
} as const;

export type TriggerHideReason = typeof TRIGGER_HIDE_REASONS[keyof typeof TRIGGER_HIDE_REASONS];

export interface TriggerVisibilityEvents {
    [TRIGGER_VISIBILITY_EVENTS.TRIGGER_VISIBILITY_CHANGED]: {
        // Undefined means the change applies to every widget on the page
        widgetId?: string;
        reason: TriggerHideReason;
        visible: boolean;
    };
}
